module.exports = __webpack_public_path__ + "static/slide3-4f34f9788182df1d2296cb8bf721e851.jpg";